import React from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";
import { Chat, QAndA } from "components";

const Interaction = () => {
  return (
    <Container>
      <Tabs>
        <Tab>Questions & Answers</Tab>
      </Tabs>
      <Modules>
        <AnimatePresence>
          <QAndA />
        </AnimatePresence>
      </Modules>
    </Container>
  );
};

const Container = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  height: 500px;
  justify-self: center;
  max-width: 500px;
  position: relative;
  width: 100%;
  @media screen and (min-width: 1150px) {
    justify-self: unset;
    max-width: unset;
    height: 100%;
  }
`;

const Modules = styled.div`
  background-color: #fff;
  border: 1px solid #bdbdbd;
  border-radius: 2px;
  border-top: none;
  height: 100%;
  margin-top: 2.875rem;
  position: relative;
  width: 100%;
  > div {
    height: 100%;
    position: absolute;
    width: 100%;
  }
`;

const Tabs = styled.div`
  align-items: flex-end;
  background-color: transparent;
  display: flex;
  height: 2.875rem;
  left: 0;
  font-weight: 600;
  position: absolute;
  top: 0;
  width: 100%;
`;

const Tab = styled.div`
  align-items: center;
  border: 1px solid #bdbdbd;
  border-radius: 2px 2px 0 0;
  cursor: pointer;
  display: flex;
  font-size: 0.875rem;
  font-weight: 700;
  justify-content: center;
  padding: 0 1.125em;
  padding-top: 0.357em;
  position: relative;
  transition: all 200ms ease-in-out;
  background-color: #fff;
  color: #3c3c3c;
  height: 3.286em;
  width: 100%;
  :before {
    border: 1px solid var(--abbvie-green);
    border-bottom: none;
    background: var(--abbvie-green);
    border-radius: 2px 2px 0 0;
    width: 100%;
    height: 0.357em;
    content: "";
    top: -1px;
    left: -1px;
    position: absolute;
  }
`;

export default Interaction;
